export default __webpack_public_path__ + "static/media/1603681385-9063.5252bd70.jpg";